/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGitAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m12 2 9.9 9.9-9.9 9.899-9.9-9.9zm0 2.7-1.437 1.436 5.884 5.804-1.414 1.414L13 11.35V14h-2V9.377L9.148 7.551 4.8 11.899l7.2 7.2 7.2-7.2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgGitAlt as GitAlt };
